<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="코칭스탭" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="코칭스탭" tabActive="1"></dept3-tab>
                <sub-staff-tab baseball />

                <staff-profile-layout v-bind="profile" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import StaffTop from "@/components/client/ko/sub/sub-staff-top.vue";

import SubStaffTab from "@/components/client/ko/sub/sub-staff-tab.vue";
import StaffProfileLayout from '@/components/client/ko/center/staff-profile-layout.vue';

export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        SlidePrimary,
        StaffTop,

        SubStaffTab,
        StaffProfileLayout,
    },
    data() {
        return {
            profile: [
                {
                    position: "감독",
                    name: "박상혁",
                    instagram: "https://www.instagram.com/park.sang.hyuk",
                    items: [
                        {
                            subject: "학력 / 경력",
                            content: [
                                "마산고등학교",
                                "KIA타이거즈",
                                "NC다이노스",
                                //
                            ],
                        },
                        {
                            subject: "상훈 / 자격증",
                            content: [
                                "전문 스포츠 지도자 2급(야구)",
                                //
                            ],
                        },
                        {
                            subject: "지도",
                            content: [
                                "재단법인 유더스타스포츠 진로체험 담당 감독",
                                //
                            ],
                        },
                        {
                            subject: "이메일",
                            content: [
                                "park.academy@uthestar.org",
                                //
                            ],
                        },
                    ],
                    image: "/images/sub/center/staff/staff-02.jpg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped></style>
